'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';

import cx from 'clsx';

import Button from 'components/ui/Button';
import Img from 'components/ui/Img';
import SvgIcon from 'components/ui/SvgIcon';
import Text from 'components/ui/Text';
import Video from 'components/ui/Video';
import VideoPlayerYTPortal from 'components/ui/VideoPlayerYT/VideoPlayerYTPortal';

import styles from './Hero.module.scss';

const bgImage = {
    url: 'https://images.ctfassets.net/j8tkpy1gjhi5/15Y3FznlZDuBq8pLnLJhxY/7c81fcd45adb652c90e3147e34d0fea1/mobile-small-background.png',
    width: 710,
    height: 1152,
};

const bgImageLarge = {
    url: 'https://images.ctfassets.net/j8tkpy1gjhi5/4f5KxU7nIchnkXqeKVraj3/881f0b61ec8979528085c948194050ad/tales-hero-desktop-background.png',
    width: 2080,
    height: 1560,
};

const fgImageLarge = {
    url: 'https://images.ctfassets.net/j8tkpy1gjhi5/53GODOeHEUMQIlFSOJDUly/44fc40a54ae1375ffd6975383523effa/tales-hero-desktop-boat.png',
    width: 2080,
    height: 1560,
};

const videoTexture = {
    mp4: 'https://videos.ctfassets.net/j8tkpy1gjhi5/01sGS2thXNMzkY9uriLGap/f5af693bb4c8fe67d59abf6251e0ec22/tot-textural-corner-hero.mp4',
    webm: 'https://videos.ctfassets.net/j8tkpy1gjhi5/11kbvY107uCgVvr0OeAbHg/969b4d4912e08486d0d87d813769b07e/tot-textural-corner-hero.webm',
    poster: 'https://images.ctfassets.net/j8tkpy1gjhi5/709IQl1qUghwFpKB8LENKx/452a23869e70d932f03ba9e2db6e4006/tot-textural-corner-hero.jpg',
};

const Hero = () => {
    const rootRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [isInView, setIsInView] = useState(false);

    const intersection = useIntersection(rootRef, {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: 0,
    });

    const handleVideoBugClick = () => {
        setIsOpen(true);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    useEffect(() => {
        intersection && intersection.isIntersecting ? setIsInView(true) : null;
    }, [intersection]);

    const renderVideoButton = () => {
        return (
            <Button
                theme=""
                className={styles.videoBugButton}
                onClick={handleVideoBugClick}
                gtm-label="hero-video-bug-cta"
                aria-label="Play video"
            >
                <span className={styles.videoBugInner}>
                    <Video
                        textural
                        className={styles.videoBugTextural}
                        poster={videoTexture.poster}
                        sources={[videoTexture.webm, videoTexture.mp4]}
                        aria-hidden="true"
                    />
                    <div className={styles.videoBugIcon}>
                        <SvgIcon type="playVideo" />
                    </div>
                </span>
            </Button>
        );
    };

    return (
        <section
            ref={rootRef}
            className={cx(styles.root, {
                [styles.isInView]: isInView,
            })}
        >
            <div className={styles.inner}>
                <div className={styles.content}>
                    <Img
                        className={styles.background}
                        src={bgImage.url}
                        width={bgImage?.width}
                        height={bgImage?.height}
                        fallbackImageWidth={1600}
                        alt="Morning Star III boat on the water background"
                        customSources={[
                            {
                                breakpoint: 768,
                                src: bgImageLarge.url,
                                imageWidth: 1920,
                            },
                            {
                                src: bgImage.url,
                                imageWidth: 1600,
                            },
                        ]}
                    />
                    <Img
                        className={styles.foreground}
                        src={fgImageLarge.url}
                        fallbackImageWidth={1280}
                        alt="Morning Star III boat on the water foreground"
                        customSources={[
                            {
                                breakpoint: 768,
                                src: fgImageLarge.url,
                                imageWidth: 1920,
                            },
                            {
                                src: fgImageLarge.url,
                                imageWidth: 1920,
                            },
                        ]}
                    />
                    <div className={styles.lockup}>
                        <Text
                            as="h1"
                            className={styles.headline}
                            baseTheme="displayMedium"
                            themes={{
                                medium: 'displayLarge',
                                large: 'displayXXLarge',
                            }}
                        >
                            TAKING DAIRY FURTHER since 1909.
                        </Text>
                        <div
                            className={cx(
                                styles.videoBug,
                                styles.videoBugDesktop
                            )}
                        >
                            {renderVideoButton()}
                        </div>
                    </div>
                    <div className={styles.videoBugContainerMobile}>
                        <div
                            className={cx(
                                styles.videoBug,
                                styles.videoBugMobile
                            )}
                        >
                            {renderVideoButton()}
                        </div>
                    </div>
                </div>
            </div>
            <VideoPlayerYTPortal
                isOpen={isOpen}
                youtubeVideoId="DVA1JZWpf2Q?si=b61Q7qsDeGXaFWj2"
                handleClose={handleClose}
            />
        </section>
    );
};

export default Hero;
